(function () {
  // ---------------------------------------------------------------------------
  // Small animation helpers replacing the jQuery effects this file used to rely
  // on (slideToggle / slideUp / slideDown / fadeIn / fadeOut / hide(duration)).
  // ---------------------------------------------------------------------------
  function isHidden(el) {
    // el.hidden covers the [hidden] attribute; computed display covers CSS/inline
    // display:none. offsetParent is unreliable for position:fixed elements.
    return !el || el.hidden || getComputedStyle(el).display === 'none';
  }

  // These helpers each schedule a deferred display/cleanup step. A later helper
  // call on the same element must cancel the pending one, or a stale timer can
  // hide an element that was just shown (e.g. rapid scroll toggling the sticky bar).
  function clearAnimationTimer(el) {
    if (el && el._animationTimer) {
      clearTimeout(el._animationTimer);
      el._animationTimer = null;
    }
  }

  function fadeIn(el, duration) {
    if (!el) return;
    clearAnimationTimer(el);
    duration = duration == null ? 400 : duration;
    el.style.removeProperty('display');
    if (getComputedStyle(el).display === 'none') el.style.display = 'block';
    el.style.opacity = '0';
    void el.offsetHeight;
    el.style.transition = 'opacity ' + duration + 'ms linear';
    el.style.opacity = '1';
  }

  function fadeOut(el, duration) {
    if (!el) return;
    clearAnimationTimer(el);
    duration = duration == null ? 400 : duration;
    el.style.transition = 'opacity ' + duration + 'ms linear';
    el.style.opacity = '0';
    el._animationTimer = window.setTimeout(function () {
      el.style.display = 'none';
      el._animationTimer = null;
    }, duration);
  }

  function slideDown(el, duration) {
    if (!el) return;
    clearAnimationTimer(el);
    duration = duration == null ? 400 : duration;
    el.style.removeProperty('display');
    if (getComputedStyle(el).display === 'none') el.style.display = 'block';
    // Clear any opacity left behind by a prior fadeOut, so the element that
    // slides down is actually visible (e.g. the sticky bar re-shown after scroll).
    el.style.removeProperty('opacity');
    var target = el.scrollHeight;
    el.style.overflow = 'hidden';
    el.style.height = '0px';
    void el.offsetHeight;
    el.style.transition = 'height ' + duration + 'ms ease';
    el.style.height = target + 'px';
    el._animationTimer = window.setTimeout(function () {
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
      el._animationTimer = null;
    }, duration);
  }

  function slideUp(el, duration) {
    if (!el) return;
    clearAnimationTimer(el);
    duration = duration == null ? 400 : duration;
    el.style.overflow = 'hidden';
    el.style.height = el.scrollHeight + 'px';
    void el.offsetHeight;
    el.style.transition = 'height ' + duration + 'ms ease';
    el.style.height = '0px';
    el._animationTimer = window.setTimeout(function () {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
      el._animationTimer = null;
    }, duration);
  }

  function slideToggle(el, duration) {
    if (!el) return;
    if (isHidden(el)) slideDown(el, duration);
    else slideUp(el, duration);
  }

  function documentReady(fn) {
    // Matches jQuery's .ready(): fires immediately if the DOM is already parsed.
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  var is_visible = true;

  //READ MORE
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.moreless-button');
    if (!button) return;

    document.querySelectorAll('.desc_more').forEach(function (el) {
      slideToggle(el);
    });

    // Mirrors the original: the label is read from the first .moreless-button.
    var first = document.querySelector('.moreless-button');
    if (first && first.textContent.trim() === 'Read more') button.textContent = 'Read less';
    else button.textContent = 'Read more';
  });

  // Product pages that opt out of the sticky add-to-cart bar.
  var STICKY_ATC_EXCLUDED = [
    '/avalon-12pc-silver-cookware-set',
    '/gladiator-series-8-meat-chopper',
    '/omega-series-steak-knives-set-of-4',
    '/gladiator-series-3-75-poultry-boning-knife',
    '/avalon-9-black-skew-frypan',
    '/avalon-series-3-qt-pot-5-ply-copper-core-with-lid-black',
    '/ss-x-6-in-serrated-utility',
    '/quantum-1-series-4-paring-knife',
    '/oberon-6pc-cookware-set',
    '/ss-x-3-75-in-serrated-paring',
    '/crusader-series-8-5-kiritsuke-chef-knife',
    '/products/oberon-5-qt-silver-stock-pot',
    '/oberon-12-non-stick-wok',
    '/avalon-6pc-silver-cookware-set',
    '/omega-series-6-curved-boning-knife',
    '/oberon-12-qt-silver-stock-pot',
    '/alon-10-black-skew-frypan',
    '/crusader-series-steak-knife-set',
    '/quantum-1-series-6-utility-knife',
    '/avalon-9-silver-skew-frypan',
    '/oberon-8-qt-silver-stock-pot',
    '/avalon-10-silver-skew-frypan',
    '/quantum-1-series-7-cleaver-knife',
    '/products/quantum-1-series-7-nakiri-vegetable-knife',
    '/avalon-8-qt-silver-pot',
    '/crusader-series-18-piece-block-set-nsf-certified',
    '/omega-series-5-5-utility-knife',
    '/shogun-series-9-meat-cleaver-the-raptor',
    '/oberon-10-sliver-skew-frypan',
    '/quantum-1-series-8-crixus-knife',
    '/copy-of-quantum-1-series-6',
    '/12-piece-cookware-set-oberon-series-dalstrong-1',
    '/oberon-4-qt-silver-saucier',
    '/dalstrong-premium-4-pocket-knife-bag-the-culinary-commander',
    '/dalstrong-double-sided-magnetic-blade-wall-storage-display-sequoina-brown',
    '/dalstrong-double-sided-magnetic-blade-wall-storage-display-vader-black',
    '/dalstrong-double-sided-magnetic-blade-wall-storage-display-frost-white',
    '/avalon-series-12-skew-frypan-5-ply-copper-core-with-lid-black',
    '/quantum-1-series-10-butcher-breaking-knife',
    '/crusader-series-8-honing-steel-nsf-certified',
    '/ballistic-series-knife-roll-dark-camo',
    '/double-sided-magnetic-blade-wall-dalstrong',
    '/dalstrong-ultimate-utility-knife-shogun-series-x-aus-10v-vacuum-treated',
    '/avalon-series-12-straight-frypan-5-ply-copper-core-with-lid-black',
    '/oberon-series-12-straight-non-stick-frypan-3-ply-aluminum-core-cookware-silver-w-lid',
    '/copy-of-avalon-series-12-straight-frypan-5-ply-copper-core-with-lid-black',
    '/oberon-series-12-non-stick-skew-frypan-3-ply-aluminum-core-cookware-silver-w-lid'
  ];

  var isStickyAtcProductPage =
    window.location.href.indexOf('/products/') > -1 &&
    !STICKY_ATC_EXCLUDED.some(function (slug) {
      return window.location.href.indexOf(slug) > -1;
    });

  if (isStickyAtcProductPage) {
    window.addEventListener('scroll', function () {
      var addToCartBtn = document.querySelector('button.add-to-cart');
      // The original read .offset() unguarded and threw on every scroll when the
      // button was absent; bail out instead.
      if (!addToCartBtn) return;

      var rect = addToCartBtn.getBoundingClientRect();
      var top_of_element = rect.top + window.pageYOffset;
      var bottom_of_element = top_of_element + addToCartBtn.offsetHeight;

      var bottom_of_screen = window.pageYOffset + window.innerHeight;
      var top_of_screen = window.pageYOffset;

      if (bottom_of_screen > top_of_element && top_of_screen < bottom_of_element) {
        // the element is visible, do something
        var existing = document.querySelector('.sticky__AddToCart');
        if (existing) fadeOut(existing, 1000);
        return;
      }

      var meta = '.product-single__meta.main__form ';
      var titleEl = document.querySelector(meta + '.product-single__title');
      var onSaleEl = document.querySelector(meta + '.product__price.on-sale');
      var priceEl = document.querySelector(meta + '.product__price');
      var savingsEl = document.querySelector(meta + '.product__price-savings');

      var prod_title = titleEl ? titleEl.outerHTML : undefined;
      var prod_price_on_sale = onSaleEl ? onSaleEl.outerHTML : '';
      var prod_price = priceEl ? priceEl.outerHTML : undefined;
      var prod_save = savingsEl
        ? '<div class="prod_savings"/>' + savingsEl.outerHTML + '</div>'
        : '';

      var add_to_cart_btn = document.querySelector(meta + '.add-to-cart');
      var bundle_add_to_cart_btn = document.querySelector('.tdf_normal_btn');

      if (is_visible) {
        // the element is not visible, do something else
        var transitionBody = document.querySelector('.transition-body');
        if (transitionBody) transitionBody.classList.add('position-relative');

        var sticky_addToCart = null;
        if (bundle_add_to_cart_btn) {
          sticky_addToCart = document.createElement('button');
          sticky_addToCart.className = 'btn';
          sticky_addToCart.textContent = 'Add To Cart';
          sticky_addToCart.addEventListener('click', function () {
            bundle_add_to_cart_btn.click();
          });
        } else if (add_to_cart_btn) {
          if (add_to_cart_btn.disabled) {
            sticky_addToCart = document.createElement('a');
            sticky_addToCart.className = 'btn btn--full klaviyo-bis-trigger';
            sticky_addToCart.setAttribute('href', '#');
            sticky_addToCart.setAttribute(
              'style',
              'text-align: center;margin: 10px 0px 0px;width: 100%;'
            );
            sticky_addToCart.textContent = 'Notify Me When Available';
          } else {
            sticky_addToCart = document.createElement('button');
            sticky_addToCart.className = 'btn';
            sticky_addToCart.textContent = 'Add To Cart';
            sticky_addToCart.addEventListener('click', function () {
              add_to_cart_btn.click();
            });
          }
        }

        var sticky_content = document.createElement('div');
        sticky_content.className = 'prod_details';
        if (sticky_addToCart) sticky_content.appendChild(sticky_addToCart);

        var sticky_bar = document.createElement('div');
        sticky_bar.className = 'sticky__AddToCart';
        sticky_bar.appendChild(sticky_content);
        if (prod_title) sticky_bar.insertAdjacentHTML('afterbegin', prod_title);

        var mainContent = document.getElementById('MainContent');
        if (mainContent && mainContent.parentNode) {
          mainContent.parentNode.insertBefore(sticky_bar, mainContent);
        }

        slideDown(sticky_bar);
        is_visible = false;
      } else {
        document.querySelectorAll('.sticky__AddToCart').forEach(function (el) {
          slideDown(el);
        });
      }
    });

    window.addEventListener('load', function () {
      if (!document.querySelector('.tdf_normal_btn')) {
        document.querySelectorAll('.main__form .product-single__form').forEach(function (el) {
          el.style.display = 'block';
        });
      }
    });

    var urlPath = window.location.pathname.replace('%C2%A9', '').split('/products/');
    shopPromotions.forEach(function (promo) {
      if (promo.promo_collection_products != null) {
        if (promo.promo_collection_products.indexOf(urlPath[1]) > -1) {
          document.querySelectorAll('.script-sale--custom-product').forEach(function (el) {
            el.style.removeProperty('display');
          });
          document.querySelectorAll('.product__price').forEach(function (el) {
            el.style.display = 'none';
          });
          document
            .querySelectorAll('.sale-script--price, .sale-script--price .product__price')
            .forEach(function (el) {
              el.style.removeProperty('display');
            });
        }
      }
    });
  }

  // Open Klaviyo Back-in-Stock modal when landing with #notifyme
  // (used by the "Notify Me" buttons on collection/search product cards).
  // Klaviyo injects its .klaviyo-bis-trigger after page load, so poll for it.
  if (
    window.location.href.indexOf('/products/') > -1 &&
    window.location.href.indexOf('#notifyme') > -1
  ) {
    var bisWaitAttempts = 0;
    var bisWaitTimer = setInterval(function () {
      var bisTrigger = document.querySelector('.klaviyo-bis-trigger');
      if (bisTrigger) {
        clearInterval(bisWaitTimer);
        bisTrigger.click();
      } else if (++bisWaitAttempts >= 40) {
        clearInterval(bisWaitTimer);
      }
    }, 250);
  }

  // Klaviyo Back-in-Stock "Notify Me" buttons on collection/search product cards.
  // Opens an in-place modal and subscribes via Klaviyo's client Back In Stock API,
  // feeding the same BIS flow as the PDP button.
  var KLAVIYO_COMPANY_ID = 'YrqkHB';
  var notifyModal = null;
  var notifyVariantId = null;

  function getNotifyModal() {
    if (notifyModal) return notifyModal;

    notifyModal = document.createElement('div');
    notifyModal.className = 'notify-me-modal';
    notifyModal.hidden = true;
    notifyModal.innerHTML =
      '<div class="notify-me-modal__overlay"></div>' +
      '<div class="notify-me-modal__box" role="dialog" aria-modal="true" aria-labelledby="NotifyMeModalHeading">' +
      '<button type="button" class="notify-me-modal__close" aria-label="Close">&#215;</button>' +
      '<h3 id="NotifyMeModalHeading" class="notify-me-modal__heading">Notify me when it\'s back</h3>' +
      '<p class="notify-me-modal__product"></p>' +
      '<form class="notify-me-modal__form" novalidate>' +
      '<input type="email" name="email" class="notify-me-modal__email" placeholder="Your email address" required>' +
      '<button type="submit" class="btn btn--full notify-me-modal__submit">Notify Me When Available</button>' +
      '<p class="notify-me-modal__error" hidden></p>' +
      '</form>' +
      '<p class="notify-me-modal__success" hidden>You\'re in! We\'ll email you as soon as it\'s back in stock.</p>' +
      '</div>';

    document.body.appendChild(notifyModal);

    notifyModal.addEventListener('click', function (event) {
      if (event.target.closest('.notify-me-modal__close, .notify-me-modal__overlay')) {
        closeNotifyModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeNotifyModal();
    });

    notifyModal.addEventListener('submit', function (event) {
      var form = event.target.closest('.notify-me-modal__form');
      if (!form) return;
      event.preventDefault();

      var error = form.querySelector('.notify-me-modal__error');
      var submit = form.querySelector('.notify-me-modal__submit');
      var email = (form.querySelector('.notify-me-modal__email').value || '').trim();

      error.hidden = true;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        error.textContent = 'Please enter a valid email address.';
        error.hidden = false;
        return;
      }

      submit.disabled = true;
      submit.textContent = 'Subscribing...';
      fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: '2024-10-15'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: email } } },
                channels: ['EMAIL']
              },
              relationships: {
                variant: {
                  data: { type: 'catalog-variant', id: '$shopify:::$default:::' + notifyVariantId }
                }
              }
            }
          })
        }
      )
        .then(function (response) {
          if (!response.ok) throw new Error('Klaviyo BIS subscription failed: ' + response.status);
          form.hidden = true;
          notifyModal.querySelector('.notify-me-modal__success').hidden = false;
        })
        .catch(function () {
          error.textContent = 'Something went wrong. Please try again.';
          error.hidden = false;
        })
        .finally(function () {
          submit.disabled = false;
          submit.textContent = 'Notify Me When Available';
        });
    });

    return notifyModal;
  }

  function closeNotifyModal() {
    if (notifyModal) notifyModal.hidden = true;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.notify-me-btn[data-notify-variant-id]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    var modal = getNotifyModal();
    var form = modal.querySelector('.notify-me-modal__form');

    notifyVariantId = btn.getAttribute('data-notify-variant-id');
    modal.querySelector('.notify-me-modal__product').textContent =
      btn.getAttribute('data-notify-product-title') || '';
    modal.querySelector('.notify-me-modal__error').hidden = true;
    modal.querySelector('.notify-me-modal__success').hidden = true;
    form.hidden = false;

    var submit = form.querySelector('.notify-me-modal__submit');
    submit.disabled = false;
    submit.textContent = 'Notify Me When Available';

    modal.hidden = false;
    form.querySelector('.notify-me-modal__email').focus();
  });

  // product-form.liquid renders the add-to-cart and the "Notify Me" button together and
  // hides whichever one does not apply to the current variant, so the right button is
  // painted with the page instead of being swapped in later by Klaviyo. Keep that pair
  // in sync when the shopper switches variant.
  function syncProductNotifyButtons(variant) {
    var notifyBtns = document.querySelectorAll('[data-product-notify-me]');
    if (!notifyBtns.length) return;

    var soldOut = !variant || !variant.available;

    notifyBtns.forEach(function (btn) {
      btn.classList.toggle('is-notify-hidden', !soldOut);
      if (variant) btn.setAttribute('data-notify-variant-id', variant.id);
    });

    document
      .querySelectorAll(
        '.product-single__form .add-to-cart:not([data-external-checkout-trigger])'
      )
      .forEach(function (btn) {
        btn.classList.toggle('is-notify-hidden', soldOut);
      });
  }

  document.addEventListener('variant:change', function (event) {
    syncProductNotifyButtons(event.detail && event.detail.variant);
  });

  //COLLECTION PAGE
  if (
    window.location.href.indexOf('/collections/') > -1 &&
    window.location.href.indexOf('/products/') < 0
  ) {
    var SectionUpdate = function () {
      var activeCollection = window.location.href.split('/')[4].split('?')[0];

      document.querySelectorAll('.blog__section').forEach(function (el) {
        if (!el.classList.contains('hide')) el.classList.add('hide');
      });

      document
        .querySelectorAll('.promo-grid div.flex-grid__item[class*="type-"]')
        .forEach(function (el) {
          if (!el.classList.contains('hide') && el.getAttribute('id') !== '') {
            el.classList.add('hide');
          }
        });

      fetch('/collections/' + activeCollection + '.json')
        .then(function (response) {
          if (!response.ok) throw new Error('Collection fetch failed: ' + response.status);
          return response.json();
        })
        .then(function (data) {
          document
            .querySelectorAll('#shopify-section-collection-header .section-header__title')
            .forEach(function (el) {
              el.textContent = data.collection.title;
            });
        })
        .catch(function () {});

      var collectionId = '#' + CSS.escape(activeCollection);
      document
        .querySelectorAll('.footer-promotions ' + collectionId + ', .promo-grid ' + collectionId)
        .forEach(function (el) {
          el.classList.remove('hide');
          el.style.removeProperty('display');
        });
    };

    documentReady(function () {
      SectionUpdate();
    });

    var click_count = 0;
    var lastUrl = location.href;
    new MutationObserver(function () {
      var url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        onUrlChange();
      }
    }).observe(document, { subtree: true, childList: true });

    var addProductRatings = function (src) {
      setTimeout(function () {
        document.querySelectorAll('script[src="' + src + '"]').forEach(function (el) {
          el.remove();
        });
        var script = document.createElement('script');
        script.src = src;
        document.head.appendChild(script);
      }, 1000);
    };

    var onUrlChange = function () {
      SectionUpdate();
      if (window.location.href.indexOf('.com') > -1) {
        addProductRatings('https://cdn.opinew.com/shop-widgets/static/js/index.3c97cee4.js');
      }
      if (click_count < 1) {
        click_count++;
      }
    };

    window.addEventListener('load', function () {
      document.querySelectorAll('.promo-grid').forEach(function (el) {
        el.style.removeProperty('display');
      });
    });
  }

  // Progress bars
  documentReady(function () {
    document.querySelectorAll('.progress .progress-bar').forEach(function (bar) {
      var now = bar.getAttribute('aria-valuenow');
      var max = bar.getAttribute('aria-valuemax');
      bar.style.width = (now / max) * 100 + '%';
    });
  });

  //Smooth Scroll
  // Add smooth scrolling to all links
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.smooth_scroll');
    if (!link) return;

    // Make sure this.hash has a value before overriding default behavior
    if (link.hash === '') return;

    // Prevent default anchor click behavior
    event.preventDefault();

    // Store hash
    var hash = link.hash;
    var target = document.querySelector(hash);
    if (!target) return;

    var top = target.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top: top, behavior: 'smooth' });

    // Reflect the hash in the URL without the browser's instant jump-to-anchor
    // (setting location.hash after a timer could snap the page mid-smooth-scroll).
    history.pushState(null, '', hash);
  });

  //COUNTRY SELECTOR TOP BAR
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('#showCountrySelector');
    if (opener) {
      fadeIn(document.querySelector('#switchLocation.modal'));
      opener.setAttribute('aria-expanded', 'true');
      return;
    }

    if (event.target.closest('#switchLocation .adl-close')) {
      fadeOut(document.querySelector('#switchLocation.modal'));
      document.querySelectorAll('#showCountrySelector').forEach(function (el) {
        el.setAttribute('aria-expanded', 'false');
      });
    }
  });

  window.addEventListener('click', function (event) {
    if (event.target === document.querySelector('div#switchLocation.modal')) {
      fadeOut(document.querySelector('#switchLocation.modal'));
      document.querySelectorAll('#showCountrySelector').forEach(function (el) {
        el.setAttribute('aria-expanded', 'false');
      });
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const pageLang = document.documentElement.getAttribute('lang') || 'en';
    const applyLangFix = (root) => {
      root.querySelectorAll('[lang=""]').forEach((el) => {
        el.setAttribute('lang', pageLang);
      });
    };
    applyLangFix(document);

    const langObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          const el = node;
          if (el.matches && el.matches('[lang=""]')) {
            el.setAttribute('lang', pageLang);
          }
          if (el.querySelectorAll) {
            applyLangFix(el);
          }
        });
      });
    });
    langObserver.observe(document.body, { childList: true, subtree: true });

    document.querySelectorAll('video').forEach((video) => {
      const containerAlt = video.closest('[data-alt]')?.getAttribute('data-alt');
      const label =
        video.getAttribute('aria-label') ||
        video.getAttribute('title') ||
        video.getAttribute('data-alt') ||
        containerAlt ||
        'Video preview';

      if (!video.getAttribute('aria-label')) {
        video.setAttribute('aria-label', label);
      }

      const fallbackImg = video.querySelector('img');
      if (fallbackImg && (!fallbackImg.getAttribute('alt') || fallbackImg.getAttribute('alt').trim() === '')) {
        fallbackImg.setAttribute('alt', label);
      }
    });

    document.querySelectorAll('.open-modal-btn').forEach((btn) => {
      const hasText = btn.textContent && btn.textContent.trim().length > 0;
      if (!hasText && !btn.getAttribute('aria-label')) {
        const labelSource = btn.getAttribute('data-modal-title') || btn.getAttribute('data-target') || 'Open details';
        btn.setAttribute('aria-label', labelSource.replace('#', '').replace(/[-_]/g, ' ').trim());
      }
    });

    const setOpinewThumbAlts = (root) => {
      root.querySelectorAll('img.opw-object-cover.opw-square-thumb').forEach((img) => {
        if (!img.hasAttribute('alt')) {
          img.setAttribute('alt', '');
        }
      });
    };
    setOpinewThumbAlts(document);
    const opinewThumbObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          const el = node;
          if (el.matches && el.matches('img.opw-object-cover.opw-square-thumb')) {
            if (!el.hasAttribute('alt')) {
              el.setAttribute('alt', '');
            }
          }
          if (el.querySelectorAll) {
            setOpinewThumbAlts(el);
          }
        });
      });
    });
    opinewThumbObserver.observe(document.body, { childList: true, subtree: true });

    // Add aria-label to Opinew sort-by select for accessibility
    const labelOpinewSelects = (root) => {
      root.querySelectorAll('select.opw-filterSortByButton:not([aria-label])').forEach((select) => {
        select.setAttribute('aria-label', 'Sort reviews by rating');
      });
    };
    labelOpinewSelects(document);
    const opinewSelectObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('select.opw-filterSortByButton:not([aria-label])')) {
            node.setAttribute('aria-label', 'Sort reviews by rating');
          }
          if (node.querySelectorAll) {
            labelOpinewSelects(node);
          }
        });
      });
    });
    opinewSelectObserver.observe(document.body, { childList: true, subtree: true });

    // Remove underline from Shopify subscription policy button
    const subPolicyBtn = document.getElementById('shopify-subscription-policy-button');
    if (subPolicyBtn) {
      subPolicyBtn.style.textDecoration = 'none';
    }

    // Remove empty underlined spans that trigger accessibility alerts
    document.querySelectorAll('span[style*="text-decoration:underline"]').forEach((span) => {
      const textContent = span.textContent.trim();
      if (!textContent || !span.closest('a')) {
        span.style.textDecoration = 'none';
      }
    });

    // Fix all video aria-labels and add captions for accessibility
    const updateVideoAriaLabels = (root) => {
      root.querySelectorAll('video[aria-label="Video preview"]').forEach((video) => {
        let newLabel = 'Product video';

        // Try to find descriptive context near the video
        const parentSlide = video.closest('.swiper-slide');
        if (parentSlide) {
          const heading = parentSlide.querySelector('h3, h2, h4, .primary_text');
          if (heading && heading.textContent.trim()) {
            newLabel = heading.textContent.trim();
          }
        }

        // Check for specific sections
        if (video.closest('.chef__video')) {
          newLabel = newLabel !== 'Product video' ? newLabel : 'Chef demonstration video';
        } else if (video.closest('.videowise-background')) {
          newLabel = 'Product demonstration video';
        } else if (video.closest('.hero, .hero__image-wrapper, .slideshow')) {
          newLabel = 'Hero banner video';
        } else if (video.closest('.pdp-video, .product-single')) {
          newLabel = 'Product detail video';
        } else if (video.closest('.review-with-video-section')) {
          newLabel = 'Customer review video';
        } else if (video.closest('.image-wrapper, .video, .wrap')) {
          newLabel = 'Product demonstration video';
        }

        video.setAttribute('aria-label', newLabel);
      });
    };

    // Run immediately
    updateVideoAriaLabels(document);

    // Run again after a short delay to catch lazy-loaded videos
    setTimeout(() => {
      updateVideoAriaLabels(document);
    }, 1000);

    // Run again after Shopify sections load
    setTimeout(() => {
      updateVideoAriaLabels(document);
    }, 2000);

    const videoObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          const el = node;
          if (el.matches && el.matches('video[aria-label="Video preview"]')) {
            updateVideoAriaLabels(el.parentElement || document);
          }
          if (el.querySelectorAll) {
            updateVideoAriaLabels(el);
          }
        });
      });
    });
    videoObserver.observe(document.body, { childList: true, subtree: true });
  });


  //BLOG PAGE - INFINITE SCROLL
  if (
    window.location.href.indexOf('/blogs/news') > -1 &&
    window.location.href.indexOf('/blogs/news/') < 0
  ) {
    document.addEventListener('DOMContentLoaded', function () {
      var endlessScroll = new Ajaxinate({
        container: '#AjaxinateLoop',
        pagination: '#AjaxinatePagination',
        method: 'click'
      });
    });
  }

  //SWIPER CAROUSEL
  if (window.location.href.indexOf('/blogs/') > -1) {
    window.addEventListener('load', function () {
      document.querySelectorAll('#shopify-section-blog-related-articles').forEach(function (el) {
        el.style.removeProperty('display');
      });
      const swiper = new Swiper('.swiper.blog-related-articles-slider', {
        // Optional parameters
        slidesPerView: 5,
        slidesPerColumnFill: 'row',
        slidesPerGroup: 5,
        spaceBetween: 5,
        freeMode: true,
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          320: {
              slidesPerView: 2,
              slidesPerGroup: 2,
          },
          640: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1020: {
            slidesPerView: 5,
            slidesPerGroup: 5,
          }
        }
      });
      window.addEventListener('resize', function () {
        swiper
      });
    });
  }

  //VIDEO COLLECTION PAGE
  if (window.location.href.indexOf('/dalstrong-films') > -1) {
    document.addEventListener('click', function (event) {
      var thumb = event.target.closest('.video-thumb');
      if (!thumb) return;

      var wrapper = document.querySelector('#videoModal .video-wrapper');
      if (!wrapper) return;

      var videoId = thumb.dataset.videoId;
      var videoType = thumb.dataset.videoType;

      if (videoId !== '' && videoId !== undefined) {
        if (videoType === 'youtube') {
          wrapper.innerHTML =
            '<iframe src="//www.youtube.com/embed/' +
            videoId +
            '?rel=0&showinfo=0&vq=720" width="850" height="480" frameborder="0" allowfullscreen></iframe>';
        }
        if (videoType === 'vimeo') {
          wrapper.innerHTML =
            '<iframe src="//player.vimeo.com/video/' +
            videoId +
            '?color={{ settings.color_button | remove: "#" }}&byline=0&portrait=0&badge=0" width="850" height="480" frameborder="0" allowfullscreen></iframe>';
        }
      } else {
        wrapper.innerHTML =
          '<iframe src="//www.youtube.com/embed/_9VUPq3SxOc?rel=0&showinfo=0&vq=720" width="850" height="480" frameborder="0" allowfullscreen></iframe>';
      }

      fadeIn(document.getElementById('videoModal'));
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('#video-modal-close')) return;
      var wrapper = document.querySelector('#videoModal .video-wrapper');
      if (wrapper) wrapper.innerHTML = '';
      fadeOut(document.getElementById('videoModal'));
    });

    window.onclick = function (event) {
      if (event.target === document.getElementById('videoModal')) {
        var wrapper = document.querySelector('#videoModal .video-wrapper');
        if (wrapper) wrapper.innerHTML = '';
        fadeOut(document.getElementById('videoModal'));
      }
    };
  }

  // BLOG ARTICLE PAGE - For table of content and mobile subcription form display
  if (window.location.href.indexOf('/blogs/') > -1) {
    const join = document.querySelector('.show_form');
    const form = document.querySelector('.mobile_subcribe_now');

    if (join) {
      join.addEventListener('click', () => {
        form.classList.toggle('active');
      });
    }

    if (document.getElementById('table')) {
      const x = Array.from(document.getElementById('table').children);

      var newlistDiv = document.getElementById('new_table');
      var newlist = '<ol>';
      x.forEach(function (y, i) {
        var section = parseInt(i) + 1;
        newlist += "<li><a class ='smooth_scroll' href = '#section" + section + "'>" + y.innerText + '</a></li>';
      });
      newlist += '</ol>';

      newlistDiv.innerHTML = newlist;
    }

    if (document.getElementById('table')) {
      const x = Array.from(document.getElementById('table').children);

      var newlistDiv = document.getElementById('mobile_table');
      var newlist = '<ol>';
      x.forEach(function (y, i) {
        var section = parseInt(i) + 1;
        newlist += "<li><a class ='smooth_scroll' href = '#section" + section + "'>" + y.innerText + '</a></li>';
      });
      newlist += '</ol>';

      newlistDiv.innerHTML = newlist;
    }
  }

  window.addEventListener('load', function () {
    window.addEventListener('scroll', function () {
      if (!document.getElementById('gfp_shopper_toolbar')) return;
      document.querySelectorAll('.site-header-sticky .site-header--stuck').forEach(function (el) {
        el.style.top = '20px';
      });
      document
        .querySelectorAll('.site-header-sticky:not(.site-header--stuck)')
        .forEach(function (el) {
          el.style.top = '0px';
        });
    });
  });

  //CUSTOM ADD TO CART
  function customAddCart() {
    document.querySelectorAll('.custom-add-cart').forEach(function (addToCart) {
      addToCart.addEventListener('click', function (evt) {
        evt.preventDefault();
        addToCart.classList.add('btn--loading');

        var addData;
        if (addToCart.getAttribute('data-preorder')) {
          addData = {
            id: addToCart.getAttribute('data-product-id'),
            quantity: 1,
            properties: {
              'Pre-Order': 'Pre-Order'
            }
          };
        } else {
          addData = {
            id: addToCart.getAttribute('data-product-id'),
            quantity: 1
          };
        }

        fetch('/cart/add.js', {
          body: JSON.stringify(addData),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
          },
          method: 'POST'
        })
          .then(function (response) {
            // fetch resolves for 4xx/5xx; guard so a 422 (unavailable/invalid
            // variant) doesn't fall through to opening the cart as if it succeeded.
            if (!response.ok) throw new Error('Cart add failed: ' + response.status);
            return response.json();
          })
          .then(function (json) {
            document.dispatchEvent(new CustomEvent('cart:build'));
            var drawer = document.querySelector('a.js-drawer-open-cart');
            if (drawer) drawer.click();
            addToCart.classList.remove('btn--loading');
            cartItemCounter();
          })
          .catch(function (err) {
            // Clear the spinner too, now that a failed add reaches here.
            addToCart.classList.remove('btn--loading');
            console.error(err);
          });
      });
    });
  }
  customAddCart();

  document.addEventListener('click', function (event) {
    if (!event.target.closest('#announcement-bar--close')) return;
    document.querySelectorAll('.announcement-bar').forEach(function (el) {
      slideUp(el);
    });
  });

  setTimeout(function () {
    document.querySelectorAll('iframe').forEach(function (iframe) {
      iframe.removeAttribute('autoplay');
      iframe.removeAttribute('allow');
    });
  }, 1000);
})();

document.addEventListener('click', function (event) {
  var button = event.target.closest('.quick-add-to-cart');
  if (!button) return;
  addToCartClickHandler.call(button, event);
});

function addToCartClickHandler(e) {
  e.preventDefault();
  var id = this.getAttribute('value');

  // $.ajax defaulted to application/x-www-form-urlencoded, so keep that encoding.
  fetch('/cart/add', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: 'id=' + encodeURIComponent(id) + '&quantity=1'
  })
    .then(function (response) {
      // fetch resolves for 4xx/5xx; don't open the cart on a failed add.
      if (!response.ok) throw new Error('Cart add failed: ' + response.status);
      return response.json();
    })
    .then(openCart)
    .catch(function (err) {
      console.error(err);
    });
}

function openCart(product) {
  // Rebuild the cart and open the drawer, mirroring customAddCart().
  // Dispatching 'ajaxProduct:added' on its own never opened the drawer: the only
  // listener for it in theme.js belongs to a pre-order field component.
  document.dispatchEvent(new CustomEvent('cart:build'));
  var drawer = document.querySelector('a.js-drawer-open-cart');
  if (drawer) drawer.click();

  // Kept for anything still listening for the original event.
  openCartDrawer(product);
}
function openCartDrawer(product) {
  document.dispatchEvent(
    new CustomEvent('ajaxProduct:added', {
      detail: {
        product: product
      }
    })
  );
}

// Product-card "front video" previews (custom_front_video metafield) render without
// the autoplay attribute so off-screen carousel slides don't download in full; this
// starts/stops playback per card only once it actually scrolls into view.
(function () {
  function initLazyCardVideos() {
    var videos = document.querySelectorAll('.lazy-card-video:not([data-lazy-video-bound])');
    if (!videos.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '200px 0px' });

    videos.forEach(function (video) {
      video.dataset.lazyVideoBound = 'true';
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyCardVideos);
  } else {
    initLazyCardVideos();
  }
  document.addEventListener('shopify:section:load', initLazyCardVideos);
  document.addEventListener('page:loaded', initLazyCardVideos);
})();

// The header cart bubble's continuous ring-pulse (theme.css.liquid) runs purely off the
// .cart-link__bubble--visible class
(function () {
  function syncCartBubble() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-link__bubble').forEach(function (bubble) {
          bubble.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
        });
      })
      .catch(function () {});
  }

  document.addEventListener('cart:drawer:refreshed', syncCartBubble);
  document.addEventListener('ajaxProduct:added', syncCartBubble);
  document.addEventListener('cart:build', syncCartBubble);
  window.addEventListener('pageshow', syncCartBubble);
})();
